module.exports = __webpack_public_path__ + "img/logo5.0f8cb9b0.png";